// extracted by mini-css-extract-plugin
module.exports = {"report-link-container":"report_link__report-link-container___2tmkR"};